export default {
    term:'',
    index: null,
    results: null
}